<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-toolbar-title class="ml-2 mt-2">{{titulo}}</v-toolbar-title>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
                <v-btn
                    class="ml-2 my-1"
                    color="primary"
                    @click="exportar()"
                >
                    <v-icon left>mdi-microsoft-excel</v-icon> Exportar
                </v-btn>
                <v-btn
                    v-if="fnImportar"
                    class="ml-2 my-1"
                    color="primary"
                    @click="abrirImportar()"
                >
                    <v-icon left>mdi-upload</v-icon> Importar
                </v-btn>
                <v-btn
                    v-if="fnApagar"
                    class="ml-2 my-1"
                    color="error"
                    @click="abrirApagar()"
                >
                    <v-icon left>mdi-delete-forever</v-icon> Apagar Dados
                </v-btn>
            </v-col>
        </v-row>
        <v-card class="mt-2 py-4 px-2" elevation="1">  
            <v-row no-gutters class="mb-4">
                <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                    <v-text-field
                        label="Período Inicial"
                        v-model="filtro.mesInicial"
                        :rules="regra.mesInicial"
                        required
                        outlined
                        dense 
                        type="month"
                        :style="$vuetify.theme.dark ? `color-scheme: dark;` : ``"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                    <v-text-field
                        label="Período Final"
                        v-model="filtro.mesFinal"
                        :rules="regra.mesFinal"
                        required
                        outlined
                        dense 
                        type="month"
                        :style="$vuetify.theme.dark ? `color-scheme: dark;` : ``"
                    ></v-text-field>
                </v-col> 
                <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                    <v-text-field
                        v-model="busca"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        dense 
                        outlined
                        hide-details
                    ></v-text-field>
                </v-col>
                
                <v-col cols="12" sm="6" md="5" lg="3" xl="3" class="px-2 ml-auto" align="end">
                    <v-btn
                        class="ml-2 mb-1"
                        color="primary"
                        @click="limpar()"
                    >
                        <v-icon left>mdi-filter-off</v-icon> Limpar
                    </v-btn> 
                    <v-btn
                        class="ml-2 mb-1"
                        color="primary"
                        @click="filtrar()"
                    >
                        <v-icon left>mdi-filter</v-icon> Filtrar
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="dados"
                :server-items-length="total" 
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 25, 50, 100]
                }"
                :options.sync="pagination"
                multi-sort
                class="elevation-0"
            >
                <template v-slot:[`item.data`]="{ item }"> 
                    {{item.data_nome}}
                </template>
                <template v-slot:[`item.valor`]="{ item }"> 
                    {{(item.valor*1).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}}
                </template>
                <template v-slot:[`item.valor_calculado`]="{ item }"> 
                    {{(item.valor_calculado*1).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}}
                </template>
            </v-data-table>
        </v-card>

        <v-dialog
            v-model="dialogoImportar"
            width="90%"
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Importar CSV
                </v-card-title>
                <v-card-text>
                    <v-alert
                        class="mt-4"
                        text
                        type="info"
                        border="left"
                        style="font-size: 12px;"
                    >
                        <ul>
                            <li>
                                Os nomes das colunas devem ser <b>idênticos</b> aos do base exportada.
                            </li>
                            <li>
                                Coluna(s) obrigatória(s): <b>{{colunasObrigatorias}}</b>.
                            </li>
                            <li>
                                Os dados da coluna <b>Tipo</b> devem ser <b>venda ou devolucao</b>, qualquer valor diferente de <b>venda ou devolucao</b> será considerado como <b>venda</b>.
                            </li>
                            <li>
                                Os dados da coluna <b>CNPJ</b> devem estar no formato <b>NN.NNN.NNN/NNNN-NN</b>.
                            </li>
                            <li>
                                Os dados da coluna <b>Data</b> devem estar no formato <b>DD/MM/AAAA</b> (dia/mês/ano).
                            </li>
                            <li>
                                A coluna <b>Valor</b> devem estar no formato moeda <b>"R$ 0.000,00"</b> com virgula <b>","</b> como separador decimal e ponto <b>"."</b> como separador de milhar.
                            </li>
                            <li>
                                Não à edição de linhas, ou seja, todos as linhas importadas são cadastradas.
                            </li>
                        </ul> 
                    </v-alert> 
                    <v-row no-gutters>
                        <v-col cols="8" class="px-2">
                            <v-form ref="form" v-model="isCsv">
                                <v-file-input 
                                    label="Arquivo CSV" 
                                    outlined 
                                    dense
                                    v-model="arquivoCSV"
                                    :rules="regra.csv"
                                    accept=".csv"
                                ></v-file-input>
                            </v-form>
                        </v-col> 
                        <v-col cols="4" class="px-2">
                            <v-btn
                                color="primary"
                                :disabled="!isCsv"
                                @click="importar()"
                            >
                                <v-icon left>mdi-upload</v-icon> 
                                Importar Arquivo
                            </v-btn>
                        </v-col> 
                    </v-row>
                    <v-row no-gutters  class="mx-2" v-show="progresso">
                        <v-col cols="12" class="px-2">
                            {{ labelProgresso }}
                        </v-col>
                        <v-col cols="12" class="px-2">
                            <v-progress-linear 
                                v-model="indexProgresso" 
                                height="25" 
                            >
                                <span class="font-weight-bold white--text">{{ Math.ceil(indexProgresso) }}%</span>
                            </v-progress-linear>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <div v-show="erro">
                            <v-row no-gutters class="mb-0">
                                <v-col cols="6">
                                    <download-csv
                                        :data="erros"
                                        :labels="errosLabels"
                                        name= "erros.csv"
                                        delimiter=";"
                                    >
                                        <v-btn color="primary">
                                            <v-icon left>mdi-microsoft-excel</v-icon>
                                            Exportar Logs
                                        </v-btn>
                                    </download-csv>
                                </v-col>
                            </v-row> 
                            <v-data-table
                                :headers="headerErros"
                                :items="erros"
                                :items-per-page="5"
                                :options.sync="paginationErros" 
                                class="elevation-0 data-table-2"
                            ></v-data-table>
                        </div>
                    </v-expand-transition>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogoImportar=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="apagar.dialogo"
            width="600"
        >  
            <v-card>
                <v-card-title class="subtitle-1 error white--text">
                    Apagar Dados
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters class="pt-6">
                        <v-form ref="formApagar">
                            <v-col cols="12" class="px-2">
                                <v-select
                                    label="Tipo"
                                    :items="apagar.tipos"
                                    v-model="apagar.tipo"
                                    required
                                    :rules="regra.tipo"
                                    dense 
                                    outlined
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="8" class="px-2" v-show="apagar.tipo=='mes'">
                                <v-text-field
                                    label="Mês"
                                    v-model="apagar.mes"
                                    :rules="regra.mes"
                                    required
                                    outlined
                                    dense 
                                    type="month"
                                    :style="$vuetify.theme.dark ? `color-scheme: dark;` : ``"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="8" class="px-2" v-show="apagar.tipo=='dia'">
                                <v-text-field
                                    label="Dia"
                                    v-model="apagar.dia"
                                    :rules="regra.dia"
                                    required
                                    outlined
                                    dense 
                                    type="date"
                                    :style="$vuetify.theme.dark ? `color-scheme: dark;` : ``"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                Você deseja realmente apagar todos os faturamentos para o {{apagar.tipo == 'mes' ? 'mês' : 'dia'}} selecionado? 
                            </v-col>
                        </v-form>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="apagar.dialogo=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                    <v-btn
                        color="error"
                        class="pr-4"
                        @click="apagarDados"
                    >
                        <v-icon left>mdi-delete-forever</v-icon> Apagar Dados
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn
                dark
                text
                class="float-right"
                @click="alerta=false"
            >
            Fechar
            </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>

export default {
    data() {
        return {
            tabela: 'faturamento',
            titulo: 'Faturamento',
            headers: [],
            ads: [],
            filtro: {},
            dados: [],
            pagination: {},
            paginationLimpa: {
                groupBy: [],
                groupDesc: [],
                itemsPerPage: 5,
                multiSort: true,
                mustSort: false,
                page: 1,
                sortBy: [],
                sortDesc: [],
            },
            total: null,
            carregando: false,
            busca: null,
            dialogoImportar: false,
            colunasObrigatorias: '',
            validaForm: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            arquivoCSV: null,
            regra: { 
                csv: [
                    v => !!v || 'Selecione um arquivo.',
                    v => (!!v && [
                        '.csv', 
                        '.CSV'
                    ].includes(v.name.substr(-4))) || 'O arquivo deve ser do tipo CSV.',
                ] ,
                mesInicial: [
                    v => !!v || 'Campo obrigatório.',
                ],
                mesFinal: [
                    v => !!v || 'Campo obrigatório.',
                    v => (!!v && v >= this.filtro.mesInicial) || 'O período final deve ser igual ou posterior ao período inicial',
                ],
                mes: [
                    v => this.apagar.tipo == 'dia' || !!v || 'Campo obrigatório.',
                ],
                dia: [
                    v => this.apagar.tipo == 'mes' || !!v || 'Campo obrigatório.',
                ],
                tipo: [v => !!v || 'Campo obrigatório.'],
            },  
            isCsv: false,
            headerErros: [
                { text: 'Tipo', value: 'tipo', align: 'center'},
                { text: 'Linha', value: 'linha', align: 'center'},
                { text: 'Descrição', value: 'msg', align: 'center'},
            ],
            erros: [],
            errosLabels: {msg: 'Descrição'},
            erro: false,
            paginationErros: {},
            progresso: false,
            indexProgresso: 0,
            labelProgresso: null,
            apagar: {
                dialogo: false,
                tipo: null,
                mes: null,
                dia: null,
                tipos: [
                    {text:'Apagar todos os faturamentos do mês selecionado.', value: 'mes'},
                    {text:'Apagar todos os faturamentos do dia selecionado.', value: 'dia'}
                ]
            },
            fnApagar: false,
            fnImportar: false,
        }
    },
    watch: {
        pagination: {
            handler () {
                this.filtrar()
            },
            deep: true,
        },
        busca(v) {

            setTimeout(() => {

                if(v == this.busca){
                    
                    this.filtrar()
                }
            }, 1000)
        },
    },
    async created() {

        this.filtro.mesInicial = this.mesAtual
        this.filtro.mesFinal = this.mesAtual

        var data = {
            id_menu: 52,
            id_cargo: this.$store.getters.getCargo.id_cargo
        }

        this.fnApagar = ( await this.$http().post('/usuario/permissaoMenu', {data: data}) ).data

        data = {
            id_menu: 51,
            id_cargo: this.$store.getters.getCargo.id_cargo
        }

        this.fnImportar = ( await this.$http().post('/usuario/permissaoMenu', {data: data}) ).data

        data = {tabela: 'faturamento.faturamento'}
        
        var tabela = await this.$http().post(`/configuracao/tabelaDados`, {data: data}) 

        this.titulo = tabela.data[0].plural
        
        var response = await this.$http().post(`/configuracao/tabela`, {data: data})

        this.headers.push({ text: 'Tipo', value: 'tipo', align: 'center'})
        this.headers.push({ text: 'Status', value: 'status', align: 'center'})
        this.headers.push({ text: 'Nota Fiscal', value: 'nota_fiscal', align: 'center'})
        this.headers.push({ text: 'Data', value: 'data', align: 'center'})
        this.headers.push({ text: 'CNPJ', value: 'cnpj', align: 'center'})

        this.colunasObrigatorias = 'Tipo, Nota Fiscal, Valor, Data, CNPJ'

        for (const [i, e] of response.data.entries()) {

            this.headers.push({ text: e.nome, value: e.ad, align: 'center'})

            if (i == 0) {

                this.headers.push({ text: 'Valor', value: 'valor', align: 'center'})
                this.headers.push({ text: 'Valor Considerado', value: 'valor_calculado', align: 'center'})
            }

            this.colunasObrigatorias += e.obrigatorio ? ', ' + e.nome : ''
        }
    },
    computed: { 
        mesAtual() {
            
            return this.$moment().format('YYYY-MM')
        },
       diaAtual() {
            
            return this.$moment().format('YYYY-MM-DD')
        },
    },
    methods: {
        async filtrar() {

            this.carregando = true

            var data = {}

            data.pagination = this.pagination
            data.busca = this.busca
            data.filtro = this.filtro

            var response = await this.$http().post(`/faturamento/lista`, {data: data})
            
            this.dados = response.data
            this.total = response.data.length ? response.data[0].total : 0

            if(this.total == 0 && this.pagination.page > 1) {

                this.pagination.page = 1
                this.filtrar(false)
            }

            this.carregando = false
        },
        limpar() {

            this.pagination = {...this.paginationLimpa}

            this.filtro = {
                mesInicial: this.mesAtual,
                mesFinal: this.mesAtual,
            }
        },
        async exportar() {
           
            this.carregando = true
            
            var data = {}

            data.filtro = this.filtro

            var response = await this.$http().post(`/faturamento/exportar`, {data: data})
          
            window.location = this.$http('baseURL')+response.data.url
            
            this.carregando = false
        }, 
        abrirImportar() {

            this.arquivoCSV = null
            this.erro = false
            this.progresso = false

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }  

            this.dialogoImportar = true 
        },
        async importar() {
            
            this.carregando = true

            this.erro = false
            this.progresso = true
            this.indexProgresso = 0
            this.labelProgresso = 'Enviando arquivo.'

            var formData = new FormData()

            formData.append("files", this.arquivoCSV)

            this.arquivoCSV = null

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }

            var response = {}
            
            await this.$http().post('/faturamento/importar', 
                formData,
                {
                    // onUploadProgress: (event) => {

                    //console.log(event.loaded, event.total) 
                    // },
                    onDownloadProgress: progressEvent => {

                        let retorno = progressEvent.currentTarget.response.split(";")

                        let obj = JSON.parse(retorno[(retorno.length - 2)])

                        this.indexProgresso = obj.index
                        this.labelProgresso = obj.label

                        response.sucesso = obj.sucesso ? obj.sucesso : null
                        response.erros = obj.erros ? obj.erros : null
                    }
                }
            )

            this.carregando = false
            this.filtrar()

            if(response.sucesso){

                this.dialogoImportar = false
            }
            else{

                this.progresso = false
                this.erros = response.erros
                this.paginationErros.page = 1
                this.erro = true
            }
        },
        abrirApagar() {

            try {
                this.$refs.formApagar.resetValidation()
            } catch (error) {
                //console.log(error)
            }

            this.apagar.tipo = 'mes'
            this.apagar.mes = this.mesAtual
            this.apagar.dia = this.diaAtual
            this.apagar.dialogo = true
        },
        async apagarDados() {

            if(!this.$refs.formApagar.validate()) return

            this.carregando = true

            var data = {}

            data = this.apagar

            var response = await this.$http().post(`/faturamento/apagar`, {data: data})
            
            this.carregando = false
            this.filtrar()

            if(response.data.sucesso){

                this.apagar.dialogo = false
            }
            else{

                this.erros = response.data.erros
                this.pagination.page = 1
                this.erro = true
            }
       }, 
    },
}
</script>